(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Track-order"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.getElementById("track-inputs-form");
  const errorEl = document.getElementById("track-error");
  const resultEl = document.getElementById("track-result");
  const submitBtn = document.getElementById("track-submit");
  const btnSpinner = submitBtn.querySelector(".btn-spinner");

  function setError(msg) {
    errorEl.textContent = msg || "";
    errorEl.style.display = msg ? "block" : "none";
  }

  function formatDateTime(iso) {
    return new Date(iso).toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true
    });
  }

  const STATUS_TO_STEP = {
    Ordered: 0,
    OrderReady: 1,
    AvailableForPickup: 2,
    IsTransist: 3,
    OutForDelivery: 4,
    Delivered: 5
  };

  function renderStepper(expectedDelivery, trackingId, orderStatus) {
    const steps = [
      "Ordered",
      "Order Ready",
      "Available for Pickup",
      "In Transit",
      "Out for Delivery",
      "Delivered"
    ];

    const activeIndex = STATUS_TO_STEP[orderStatus] ?? 0;

    return `
      <div class="tracking-header">
        <div>
          <div class="label">Expected Delivery:</div>
        </div>
        <div class="tracking-id">
          Tracking Id: ${trackingId}
        </div>
      </div>

      // <div class="stepper">
      //   ${steps.map((label, i) => `
      //     <div class="step ${i <= activeIndex ? "active" : ""}">
      //       <div class="circle">
      //         <span class="icon">✔</span>
      //       </div>
      //       <div class="step-label">${label}</div>
      //       ${i < steps.length - 1 ? `<div class="line"></div>` : ""}
      //     </div>
      //   `).join("")}
      // </div>
    `;
  }

  function renderTimeline(activity) {
    if (!activity || !activity.length) return "<p>No activity found.</p>";

    const sorted = [...activity].sort(
      (a, b) => new Date(b.activityDate || b.createAt) - new Date(a.activityDate || a.createAt)
    );

    return `
      <div class="shipment-card">
        <h3>Shipment Tracking</h3>
        <div class="timeline">
          ${sorted.map(item => `
            <div class="timeline-row">
              <div class="timeline-dot"></div>
              <div class="timeline-content">
                <div class="timeline-time">
                  ${formatDateTime(item.activityDate || item.createAt)}
                </div>
                <div class="timeline-activity">
                  ${item.activity} : ${item.message}
                </div>
                <div class="timeline-location">
                  ${item.location || ""}
                </div>
              </div>
            </div>
          `).join("")}
        </div>
      </div>
    `;
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();
    setError("");
    resultEl.innerHTML = "";

    const fd = new FormData(form);
    const searchBy = fd.get("searchBy");
    const value = String(fd.get("searchValue") || "").trim();

    if (!value) {
      setError("Please enter Order ID or Tracking ID.");
      return;
    }

    submitBtn.disabled = true;
    btnSpinner.style.display = "inline-block";

    try {
      const queryParam = searchBy === "order_id" ? "order_id" : "awb_number";
      const res = await fetch(
        `https://common.stage.lookfinity.com/amalfa/shopify/redirects/Shipment/GetTracking?${queryParam}=${value}`,
        { method: "GET", headers: { "Accept": "application/json" } }
      );

      if (!res.ok) throw new Error(await res.text());

      const data = await res.json();

      const resultData = data.result || {};

      const expectedDelivery = resultData.expectedDelivery || "TBD";

      resultEl.innerHTML = `
        ${renderStepper(expectedDelivery, value, resultData.order_status)}
        ${renderTimeline(resultData.activity)}
      `;
    } catch (err) {
      setError(err.message || "Tracking failed. Please try again.");
    } finally {
      submitBtn.disabled = false;
      btnSpinner.style.display = "none";
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
